import { useEffect, useState } from "react";
import API from "../api";
import { useLoader } from "../context/LoaderContext";

export default function Admin() {
  const [users, setUsers] = useState([]);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [backupResp, setBackupResp] = useState(null);
  const { showLoader, hideLoader, showSuccess } = useLoader();
  const [backupsAvailable, setBackupsAvailable] = useState([])

  const load = () => {
    API.get("/users").then((res) =>
      setUsers(res.data)
    );

    API.get("/db/list").then((res) => {
      console.log(res)
      console.log(res.data)
      setBackupsAvailable(res.data)
    })
  };

  useEffect(() => {
    load();
    // Aktuális user ID lekérése
    API.get("/auth/me").then((res) => {
      setCurrentUserId(res.data.id);
    });
  }, []);

  const toggle = (u) => {
    if (u.id === currentUserId && !u.is_active) {
      alert("Nem deaktiválhatod magadat!");
      return;
    }

    API.put(`/users/${u.id}`, {
      is_active: !u.is_active,
      role: u.role,
    }).then(load);
  };

  const remove = (u) => {
    if (u.id === currentUserId) {
      alert("Nem törölheted magadat!");
      return;
    }

    if (window.confirm(`Biztosan törlöd a(z) "${u.display_name}" felhasználót?`)) {
      API.delete(`/users/${u.id}`).then(load);
    }
  };

  const backup_db = () => {
    if (!window.confirm("Biztosan készítesz egy adatbázis mentést?")) return;
    showLoader("Mentés...");

    setTimeout(() => {
      API.post("/db/backup")
        .then((response) => {
          console.log("DB backup called");
          setBackupResp(response.data.message)
          setTimeout(() => {
            showSuccess("Mentés sikeres.")
            setTimeout(() => {
              hideLoader(0);
              load();
            }, 2000);
          }, 1000);
        })
        .catch((err) => {
          console.error("Backup error:", err);
          alert("Backup sikertelen.");
        });

    }, 800);
  };

  return (
    <div className="p-6">
      <h2 className="text-xl mb-4">Admin panel</h2>

      <div className="bg-white shadow p-4 rounded mb-6">
        <h3 className="mb-4 text-xl">Felhasználók</h3>

        {users.map((u) => (
          <div
            key={u.id}
            className={`border p-2 flex justify-between ${u.id === currentUserId ? "bg-yellow-100 border-yellow-500" : ""
              }`}
          >
            <div>
              <span>{u.display_name}</span>
              {u.id === currentUserId && (
                <span className="ml-2 text-sm bg-yellow-500 text-white px-2 py-1 rounded">
                  (Te vagy)
                </span>
              )}
              <p className="text-sm text-gray-600">{u.email}</p>
              <p className="text-xs text-gray-500">Role: {u.role}</p>
            </div>

            <div className="flex gap-2">
              <button
                onClick={() => toggle(u)}
                disabled={u.id === currentUserId}
                className={`text-white px-2 py-1 rounded ${u.id === currentUserId
                  ? "bg-gray-400 cursor-not-allowed"
                  : u.is_active
                    ? "bg-blue-500 hover:bg-blue-600"
                    : "bg-green-500 hover:bg-green-600"
                  }`}
              >
                {u.is_active ? "Deaktivál" : "Aktivál"}
              </button>

              <button
                onClick={() => remove(u)}
                disabled={u.id === currentUserId}
                className={`text-white px-2 py-1 rounded ${u.id === currentUserId
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-red-500 hover:bg-red-600"
                  }`}
              >
                Törlés
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-white shadow p-4 rounded mb-6">
        <h2 className="text-xl mb-4">Adatbázis </h2>
        <div className="p-4">
          <h3 className="mb-3 font-semibold">Adatbázis biztonsági mentése</h3>
          <button className="text-white px-2 py-1 rounded bg-blue-500 hover:bg-blue-600"
            onClick={() => backup_db()}
          >Adatbázis mentése készítése</button>
          {backupResp ? (
            <>
              <p className="mt-4 mb-4">
                <span className="text-green-500">A biztonsági mentés sikeresen elkészült.</span>
                <p>
                  Fájlnév: {backupResp}
                </p>
              </p>
            </>
          ) : (null)}
        </div>
        <hr></hr>
        <div className="p-4">

          <h3 className="mb-3 font-semibold">Korábbi biztonsági mentések</h3>
          <ul className="list-disc m-4">
            {backupsAvailable && backupsAvailable.length > 0 ? (
              backupsAvailable.map((backupitem, i) => (
                <li key={i}>{backupitem.name}</li>
              ))
            ) : (
              <li>No backups available</li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}